import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import * as moment from 'moment';
import {MomentDateRange} from './moment-date-range';
import {PredefinedInterval} from './predefined-interval';

@Component({
  selector: 'app-date-interval-selection',
  templateUrl: './date-interval-selection.component.html',
})
export class DateIntervalSelectionComponent implements OnInit, OnDestroy {
  @Output() dateRangeChanged: EventEmitter<MomentDateRange>;
  momentNow = moment(new Date());
  todayStart = this.momentNow.clone().set('hours', 0).set('minutes', 0).set('second', 0);
  todayEnd = this.momentNow.clone().set('hours', 23).set('minutes', 59).set('second', 59);
  yesterdayStart = this.todayStart.clone().subtract(1, 'days');
  yesterdayEnd = this.todayEnd.clone().subtract(1, 'days');
  public intervals: Array<PredefinedInterval> = [
    {
      caption: 'Today',
      from: this.todayStart,
      to: this.todayEnd,
    },
    {
      caption: 'Yesterday',
      from: this.yesterdayStart,
      to: this.yesterdayEnd,
    },
    {
      caption: '7 days',
      from: this.momentNow.clone().subtract(7, 'days').add(1, 'seconds'),
      to: this.momentNow.clone(),
    },
    {
      caption: '30 days',
      from: this.momentNow.clone().subtract(30, 'days').add(1, 'seconds'),
      to: this.momentNow.clone(),
    },
  ];
  public dateRange: BehaviorSubject<MomentDateRange> =
    new BehaviorSubject<MomentDateRange>([this.intervals[0].from, this.intervals[0].to]);
  public dateRangeSubscription: Subscription;

  constructor() {
    this.dateRangeChanged = new EventEmitter<MomentDateRange>();
  }

  ngOnInit() {
    this.dateRangeSubscription = this.dateRange.subscribe(
      dateRange => this.dateRangeChanged.emit(dateRange)
    );
  }

  ngOnDestroy() {
    this.dateRangeSubscription.unsubscribe();
  }

  intervalClick(interval: PredefinedInterval) {
    this.dateRange.next([
      interval.from, interval.to
    ]);
    // this.selectedInterval.next(interval);
    // this.dateRange = [new Date(), new Date()];
  }

  intervalIsSelected(interval: PredefinedInterval, dateRange: MomentDateRange) {
    // console.log([interval.from.format('YYYY-MM-DD'), dateRange[0].format('YYYY-MM-DD'),
    //   interval.to.format('YYYY-MM-DD'), dateRange[1].format('YYYY-MM-DD')]);
    return interval.from.format('YYYY-MM-DD') === dateRange[0].format('YYYY-MM-DD')
      && interval.to.format('YYYY-MM-DD') === dateRange[1].format('YYYY-MM-DD');
  }

  onDateTimeChange(event) {
    this.dateRange.next(event.value);
  }
}
